import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Es seguro el pago?',
  a: 'Totalmente. Procesamos los pagos a través de una plataforma segura con encriptación SSL. Tu información financiera nunca se comparte con nosotros.'
}, {
  q: '¿Cómo recibo el acceso?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con el enlace para descargar el eBook PDF y todos los bonos. Tienes acceso de por vida.'
}, {
  q: '¿Necesito saber programar o ser experta en tecnología?',
  a: '¡Para nada! El sistema está diseñado para que cualquier persona pueda usarlo. Solo necesitas saber copiar y pegar los prompts que te damos en ChatGPT.'
}, {
  q: '¿Funciona para productos físicos o solo servicios?',
  a: 'Funciona para ambos. El método A.R.P.A. se basa en psicología de ventas humana, que aplica igual si vendes ropa, accesorios, consultorías o servicios de belleza.'
}, {
  q: '¿Tengo que pagar la versión premium de ChatGPT?',
  a: 'No. Todos nuestros prompts y el sistema completo están diseñados y probados para funcionar perfectamente con la versión gratuita de ChatGPT.'
}, {
  q: '¿Qué pasa si mi nicho es muy específico?',
  a: 'La IA se adapta a tu nicho. En el manual te enseñamos exactamente cómo darle el contexto a ChatGPT para que responda como un experto en tu industria específica.'
}, {
  q: '¿Es una suscripción mensual?',
  a: 'No, es un único pago de $29.999 COP. No hay cobros ocultos ni mensualidades. Pagas una vez y el material es tuyo para siempre.'
}, {
  q: '¿Tengo garantía?',
  a: 'Sí, tienes 7 días de garantía de satisfacción. Si sientes que el material no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-92">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="text-center mb-12" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-graphite mb-4" data-id="element-95">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-96">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-97">
          {FAQS.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-colors ${openIndex === index ? 'border-primary bg-blue-50/30' : 'border-gray-200 bg-white'}`} data-id="element-98">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-99">
                <span className="font-bold text-graphite pr-4" data-id="element-100">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-primary' : ''}`} data-id="element-101" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-102">
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-103">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}